import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import {
  getMatFormFieldDuplicatedHintError,
  MatDialog,
  MatDialogConfig,
} from "@angular/material";
import { NewRecordComponent } from "../new-record/new-record.component";
import { EditRecordComponent } from "../edit-record/edit-record.component";
import * as _moment from "moment";
import { default as _rollupMoment } from "moment";
import { Router } from "@angular/router";
import { CreatePersonOfInterestModalComponent } from "./modals/create-person-of-interest/create-person-of-interest-modal.component";
import { PersonOfInterestService } from "../services/person-of-interest.service";
import { SearchService } from "../services/search.service";
import { NotificationService } from "../services/notification.service";
import { AuthService } from "../services/auth.service";
import { UpdatePersonOfInterestModalComponent } from "./modals/update-person-of-interest/update-person-of-interest-modal.component";
import { PersonOfInterest } from "../models/person-of-interest.model";
import { DatePipe } from "@angular/common";
import { ProfileRenderer } from "../renderer/profile-renderer.component";
import { ViewPersonOfInterestModalComponent } from "./modals/view-person-of-interest/view-person-of-interest-modal.component";
import { Photos } from "../models/photo.model";
import { Attachments } from "../models/attachments.model";
import { CommonService } from "../services/common.service";
import { UserService } from "../services/user.service";
import { POIRequester } from '../models/poi-requester.model';
import { DialogService } from '../services/dialog.service';
import { SearchFilterModalComponent } from '../search-filter/search-filter.modal.component';
import { TreeDropdownDynamicDatabaseService } from "../services/tree-dropdown-dynamic-database.service";
import { GridApi, ColumnApi } from "ag-grid-community";
import { SpinnerService } from "../services/spinner.service";
import { Subject, Subscription } from "rxjs";
import { SharedService } from "src/app/services/shared.service";
import { debounceTime } from "rxjs/operators";
import { CommonGridcolumnShowhideModalComponent } from "../common-gridcolumn-showhide-modal/common-gridcolumn-showhide-modal.component";
import { DownloadGridComponent } from "../download-grid/download-grid.component";
import { UtilityService } from "../services/utility.service";
const moment = _rollupMoment || _moment;

@Component({
  selector: "app-person-of-interest",
  templateUrl: "./person-of-interest.component.html",
  styleUrls: ["./person-of-interest.component.css"],
})
export class PersonOfInterestComponent implements OnInit {
  rowData: any = [];
  data: any;
  params: [];
  
  selectedPoi: PersonOfInterest;
  clickedPoi: PersonOfInterest;
  isRowSelected: boolean = false;
  private gridApi: GridApi;
  protected count: number = 0;
  public columnApi!: ColumnApi;
  public gridStateChanged$ = new Subject<void>();
  public headerJsondata: any;
  private subscription: Subscription = new Subscription();
  private photoRefreshInterval: any;
  // public defaultColDef: object;

  @ViewChild("searchField") searchField: ElementRef;
  protected selectedApp: number;
  frameworkComponents: any;
  protected userApplications: Array<{
    ApplicationID: number;
    Name: string;
    Route: string;
  }>;
  protected pinnedBottomRowData: any[] = [
    { },
  ];
  selectedSearchFilter: string = 'Wide';

  //ag-grid
  columnDefs = [
    {
        headerName: "",
        field: "",
        width: 30,
        hide: false,
        resizable: false,
        sortable: false,
        lockPosition: "left",
        lockPinned: true,
        // pinned: "left",
        colSpan: (params) => {
          if (params.node.rowPinned) {
            return params.columnApi.getAllDisplayedColumns().length;
          }
          return 1;
        },
        cellRenderer: (params) => {
          if (params.node.rowPinned) {
            const button = document.createElement('button');
            button.style.marginTop = '3px';
            button.style.backgroundColor = 'white';
            button.style.borderRadius = '3px';
            button.style.float = "left";
            button.style.border = "1px solid darkgrey";
            button.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M19.14 12.94c.04-.31.07-.63.07-.94s-.03-.63-.07-.94l2.03-1.58c.18-.14.23-.4.12-.61l-1.92-3.32c-.12-.21-.38-.3-.61-.22l-2.39.96a7.007 7.007 0 0 0-1.6-.94L14.5 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5l-.38 2.49c-.59.22-1.14.53-1.6.94l-2.39-.96a.5.5 0 0 0-.61.22L2.7 8.87a.5.5 0 0 0 .12.61l2.03 1.58c-.04.31-.07.63-.07.94s.03.63.07.94l-2.03 1.58a.5.5 0 0 0-.12.61l1.92 3.32c.12.21.38.3.61.22l2.39-.96c.46.41 1.01.72 1.6.94l.38 2.49c.03.25.25.43.5.43h4c.25 0 .47-.18.5-.43l.38-2.49c.59-.22 1.14-.53 1.6-.94l2.39.96c.23.09.49 0 .61-.22l1.92-3.32a.5.5 0 0 0-.12-.61l-2.03-1.58zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5S10.07 8.5 12 8.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/>
          </svg>Grid Settings
        `; button.addEventListener('click', () => {
              this.agGridPopUpModal(this.searchService.getPageName(), 'PersonOfInterest');
            });
            return button;
          }
          return null; // Don't render anything for normal rows
        },
      },
    // {
    //   headerName: "Person Of Interest ID",
    //   field: "PersonOfInterestID",
    //   cellStyle: { color: "#ffff" },
    //   hide: true,
    //   sortable: true,
    // },
    // {
    //   headerName: "RecordID",
    //   field: "RecordID",
    //   cellStyle: { color: "#ffff" },
    //   hide: true,
    //   sortable: true,
    // },
    {
      headerName: "Personal Information",
      lockPosition: true,
      pinned: "left",
      lockPinned: true,
      children: [
        {
          colId: 'POIProfile',
          cellRenderer: "profileRenderer",
          autoHeight: true,
          checkboxSelection: true,
          width: 120,
          lockPosition: "left",
          lockPinned: true,
        },
        {
          headerName: "Last Name",
          field: "LastName",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          sortable: true,
        },

        {
          headerName: "First Name",
          field: "FirstName",
          cellStyle: { color: "#ffff" },
          hide: false,
          sortable: true,
          //checkboxSelection: true,
        },
        {
          headerName: "Middle Name",
          field: "MiddleName",
          cellStyle: { color: "#ffff" },
          hide: false,
          sortable: true,
          columnGroupShow: "open",
        },      
        {
          headerName: "Suffix",
          field: "Suffix",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          sortable: true,
          columnGroupShow: "open",
        },
        {
          headerName: "SSN",
          field: "SSN",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          sortable: true,
        },

        {
          headerName: "Gender",
          field: "GenderName",
          // width: 175,
          cellClass: (params) => {
            return params.data.GenderActive === 0 ? "inActiveLinkedField" : "";
          },
          cellStyle: { color: "#ffff" },
          resizable: true,
          sortable: true,
        },
        {
          headerName: "Birth Date",
          field: "BirthDate",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          sortable: true,
          columnGroupShow: "open",
          valueGetter: (params) => {
            return this.utilService.formatBirthDate(
              params.data.BirthDay,
              params.data.BirthMonth,
              params.data.BirthYear
            );
          },
        },
        {
          headerName: "Aliases",
          field: "Aliases",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
      ],
    },

    //Profile

    {
      headerName: "Profile",
      lockPosition: true,
      children: [
        {
          headerName: "Height(in)",
          field: "HeightInches",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          columnGroupShow: "open",
        },
        {
          headerName: "Height(mt)",
          field: "HeightMeters",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          columnGroupShow: "open",
        },
        {
          headerName: "Weight(lb)",
          field: "WeightPounds",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          columnGroupShow: "open",
        },
        {
          headerName: "Weight(kg)",
          field: "WeightKilograms",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          columnGroupShow: "open",
        },
        {
          headerName: "Hair",
          field: "HairColor",
          cellClass: (params) => {
            return params.data.HairActive === 0 ? "inActiveLinkedField" : "";
          },
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Eyes",
          field: "EyeColor",
          cellClass: (params) => {
            return params.data.EyesActive === 0 ? "inActiveLinkedField" : "";
          },
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Race",
          field: "RaceName",
          cellClass: (params) => {
            return params.data.RaceActive === 0 ? "inActiveLinkedField" : "";
          },
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Driver License Number",
          field: "DriverLicenseNum",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
      ],
    },

    //Contact information

    // {
    //   headerName: "Contact Information",
    //   children: [
    //     {
    //       headerName: "Email",
    //       field: "Email",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //     },
    //     {
    //       headerName: "Phone",
    //       field: "Phone",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //     },
    //     {
    //       headerName: "Company",
    //       field: "Company",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //     },
    //     {
    //       headerName: "Address",
    //       field: "Address",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //       sortable: true,
    //     },
    //     {
    //       headerName: "Address2",
    //       field: "Address2",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //       sortable: true,
    //       columnGroupShow: "open",
    //     },

    //     {
    //       headerName: "Country",
    //       field: "Country",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //       sortable: true,
    //       columnGroupShow: "open",
    //     },
    //     {
    //       headerName: "State",
    //       field: "State",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //       sortable: true,
    //       columnGroupShow: "open",
    //     },
    //     {
    //       headerName: "City",
    //       field: "City",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //       sortable: true,
    //       columnGroupShow: "open",
    //     },
    //     {
    //       headerName: "Zip",
    //       field: "Zip",
    //       cellStyle: { color: "#ffff" },
    //       hide: false,
    //       resizable: true,
    //       sortable: true,
    //       columnGroupShow: "open",
    //     },
    //   ],
    // },

    //Requester Information
    {
      headerName: "Requester Information",
      lockPosition: true,
      children: [
        {
          headerName: "First Name",
          field: "Requester.FirstName",
          cellStyle: { color: "#ffff" },
          hide: false,
          sortable: true,
        },
        {
          headerName: "Last Name",
          field: "Requester.LastName",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Email",
          field: "Requester.Email",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Phone",
          field: "Requester.Phone",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Company",
          field: "Requester.Company",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Department",
          field: "Requester.Department",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          columnGroupShow: "open",
        },
        {
          headerName: "Position",
          field: "Requester.Position",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          columnGroupShow: "open",
        },
      ],
    },

    //Notification and Restriction
    {
      headerName: "Notification and Restrictions",
      lockPosition: true,
      children: [
        {
          headerName: "Restriction Type",
          field: "RestrictionTypeName",
          cellClass: (params) => {
            return params.data.RestrictionTypeActive === 0
              ? "inActiveLinkedField"
              : "";
          },
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
        },
        {
          headerName: "Restricted On Date",
          field: "RestrictedOn",
          cellStyle: { color: "#ffff" },
          valueGetter: (params) => {
            return (params.data.RestrictedOn === '0000-00-00 00:00:00' || !params.data.RestrictedOn || params.data.RestrictedOn === '') ? ' ' : moment(params.data.RestrictedOn).format('MM/DD/YYYY');
          },
          hide: false,
          resizable: true,
          sortable: true,
          columnGroupShow: "open",
        },
        {
          headerName: "Restricted End Date",
          field: "RestrictedEndDate",
          cellStyle: { color: "#ffff" },
          valueGetter: (params) => {
            return (params.data.RestrictedEndDate === '0000-00-00 00:00:00' || !params.data.RestrictedEndDate || params.data.RestrictedEndDate === '') ? ' ' : moment(params.data.RestrictedEndDate).format('MM/DD/YYYY');
          },
          hide: false,
          resizable: true,
          sortable: true,
          columnGroupShow: "open",
        },
        // {
        //   headerName: "Restricted Reason",
        //   field: "RestrictedReasonName",
        //   cellClass: (params) => {
        //     return params.data.RestrictedReasonActive === 0
        //       ? "inActiveLinkedField"
        //       : "";
        //   },
        //   cellStyle: { color: "#ffff" },
        //   hide: false,
        //   resizable: true,
        // },
        // {
        //   headerName: "Notes",
        //   field: "Notes",
        //   cellStyle: { color: "#ffff" },
        //   hide: false,
        //   resizable: true,
        //   sortable: true,
        //   columnGroupShow: "open",
        // },
        {
          headerName: "Notification Email",
          field: "NotificationEmail",
          cellStyle: { color: "#ffff" },
          hide: false,
          resizable: true,
          sortable: true,
        },
        {
          headerName: "GenderActive",
          field: "GenderActive",
          hide: true,
          resizable: true,
          sortable: true,
        },
        {
          headerName: "HairActive",
          field: "HairActive",
          hide: true,
          resizable: true,
          sortable: true,
        },
        {
          headerName: "EyesActive",
          field: "EyesActive",
          hide: true,
          resizable: true,
          sortable: true,
        },
        {
          headerName: "RaceActive",
          field: "RaceActive",
          hide: true,
          resizable: true,
          sortable: true,
        },
        {
          headerName: "RestrictionTypeActive",
          field: "RestrictionTypeActive",
          hide: true,
          resizable: true,
          sortable: true,
        },
        {
          headerName: "RestrictedReasonActive",
          field: "RestrictedReasonActive",
          hide: true,
          resizable: true,
          sortable: true,
        },
      ],
    },
  ];

  constructor(
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private http: HttpClient,
    private router: Router,
    protected authService: AuthService,
    protected notificationService: NotificationService,
    protected searchService: SearchService,
    protected personOfInterestService: PersonOfInterestService,
    protected commonService: CommonService,
    protected userService: UserService,
    protected dialogService: DialogService,
    protected treeDropdownService: TreeDropdownDynamicDatabaseService,
    protected spinnerService: SpinnerService,
    public sharedService : SharedService,
    protected utilService: UtilityService,
  ) {
    this.selectedPoi = null;
    this.selectedApp = 2;
    this.frameworkComponents = {
      profileRenderer: ProfileRenderer,
    };
    this.searchService.setPageName("Person Of Interest");
  }


  onApplicationChange(){
  this.searchService.switchApplication(this.selectedApp)
  }

  //when checkbox is checked, updates row data
  onSelectionChanged($event) {
    const selectedRows: PersonOfInterest[] = $event.api.getSelectedRows();
    if (selectedRows.length) {
      console.log("onselection",this.isRowSelected)
      this.selectedPoi = selectedRows[0];
      this.isRowSelected = true;
    } else {
      this.isRowSelected = false;
    }
  }

  //opens edit modal, send row data to modal
  updateRecord() {
    this.dialog.open(UpdatePersonOfInterestModalComponent, {
      data: this.selectedPoi,
    });
  }

  createRecord() {
    this.gridApi.deselectAll();
    const dialogNew = this.dialog.open(
      CreatePersonOfInterestModalComponent,
      {}
    );
  }

  removeRecord() {
    this.dialog.open(UpdatePersonOfInterestModalComponent, {
      data: this.selectedPoi,
    });
  }

  //make ag-rid colums fill their container
  onFirstDataRendered(params) {
    params.api.sizeColumnsToFit();
  }
  //get grid
  ngOnInit() {

    console.log("testing merge");
    
    this.spinnerService.setIsLoading(true);

    this.getDropdownData();
    // setting the page name
    this.searchService.setPageName("Person Of Interest");
    this.selectedSearchFilter = localStorage.getItem("searchType") || "Wide";
    this.searchService.selectedSearchFilter = this.selectedSearchFilter;
    this.getHeaderJsonData()
    this.gridStateChanged$.pipe(
      debounceTime(500)
    ).subscribe(() => {
      this.saveGridState();
    });
    this.searchService
    .smartSearchAPI(null)
          .then(() => {
            this.data = this.searchService.searchRecords;
            if (!this.searchField.nativeElement.value.trim()) {
              this.data?.sort((a, b) => this.sort(a, b, 'LastName'));
            }
            this.data = this.data.filter((f) => f.Active)
              if (this.data) {
                this.data.forEach(element => {                
                  var photoArray: Photos[] = this.setPhotoArray( element.PhotoIDs,element.PhotoXIDs,element.PhotoS3KeyNames,element.PhotoDescriptions,element.PhotoLogicalFileNames,element.PhotoActives,element.PrimaryPhotoID);  
                  element.PrimaryPhotoArray = [];
                  if(photoArray){
                    var primaryPhotoArray: Photos[] = photoArray.filter((f) => f.IsPrimary == true && f.Active); //get PrimaryPhoto Array
                    element.PrimaryPhotoArray = primaryPhotoArray;
                  }
                  element.PhotosArray = photoArray;
                  element.AttachmentsArray = this.setAttachmentArray(element.AttachmentIDs,element.AttachmentXIDs,element.AttachmentS3KeyNames, element.AttachmentDescriptions, element.AttachmentLogicalFileNames, element.AttachmentActives); 
                  element.AliasArray = this.setAliasArray( element.AliasIDs,element.AliasNames,element.AliasActives);
                  element.Aliases = element.AliasNames;
                  element.RecordID = element.PersonOfInterestID;  
                  element.Requester = new POIRequester(element.RequesterID,element.RequesterFirstName,element.RequesterLastName,element.RequesterEmail,element.RequesterPhone,element.RequesterCompany,element.RequesterDepartment,element.RequesterPosition,element.RequesterActive)               
                  
                });
              
                if(this.data){
                this.commonService.getPrimaryPhotoFiles(this.data).then(() =>{
                    this.commonService.primaryPhotoFileRecords.forEach(element => {
                      if(element.Photos.length > 0){
                        this.data.filter((f) => f.PersonOfInterestID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
                        this.data.filter((f) => f.PersonOfInterestID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURL = element.Photos[0].SignedURL; 
                      }         
                    });
              
                  }).catch((err)=>{
                    this.notificationService.failure(err.message);
                  }).finally(()=>{
                    this.rowData = this.data;
                  });
                  
                } 
                
              } 
              this.spinnerService.setIsLoading(false);           
          })
          .catch((err: HttpErrorResponse) => {
            this.notificationService.failure(err.message);
            this.spinnerService.setIsLoading(false);
          });

    this.subscription.add(this.searchService.searchInitiated.subscribe((eventData: boolean) => {
      if (eventData) {
        this.searchService.smartSearchPromise
          .then(() => {
            this.data = this.searchService.searchRecords;
            if (!this.searchField.nativeElement.value.trim()) {
              this.data?.sort((a, b) => this.sort(a, b, 'LastName'));
            }
            this.data = this.data.filter((f) => f.Active)
            if (this.data) {
              this.data.forEach(element => {
               
                var photoArray: Photos[] = this.setPhotoArray( element.PhotoIDs,element.PhotoXIDs,element.PhotoS3KeyNames,element.PhotoDescriptions,element.PhotoLogicalFileNames,element.PhotoActives,element.PrimaryPhotoID);  
                element.PrimaryPhotoArray = [];
                if(photoArray.length > 0){
                  var primaryPhotoArray: Photos[] = photoArray.filter((f) => f.IsPrimary == true && f.Active); //get PrimaryPhoto Array
                  element.PrimaryPhotoArray = primaryPhotoArray;
                }
                element.PhotosArray = photoArray;
                element.AttachmentsArray = this.setAttachmentArray(element.AttachmentIDs,element.AttachmentXIDs,element.AttachmentS3KeyNames, element.AttachmentDescriptions, element.AttachmentLogicalFileNames, element.AttachmentActives); 
                element.AliasArray = this.setAliasArray( element.AliasIDs,element.AliasNames,element.AliasActives);
                element.Aliases = element.AliasNames;
                element.RecordID = element.PersonOfInterestID;  
                element.Requester = new POIRequester(element.RequesterID,element.RequesterFirstName,element.RequesterLastName,element.RequesterEmail,element.RequesterPhone,element.RequesterCompany,element.RequesterDepartment,element.RequesterPosition,element.RequesterActive)                              
                
               });
                  
              //call getPOIFiles Api to set base64 for primary Photo Id , hence pass only the primaryPhoto into primaryPhotoArray 
             
              if(this.data){
                this.commonService.getPrimaryPhotoFiles(this.data).then(() =>{
                  if(this.commonService.primaryPhotoFileRecords.length > 0){
                    this.commonService.primaryPhotoFileRecords.forEach(element => {
                      if(element.Photos.length > 0){
                        if(element.RecordID !== undefined) {
                        this.data.filter((f) => f.PersonOfInterestID
                         == element.RecordID)[0].PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
                        this.data.filter((f) => f.PersonOfInterestID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURL 
                        = element.Photos[0].SignedURL; 
                      }     
                    }   
                    });
                  }
            
                }).catch((err)=>{
                  this.notificationService.failure(err.msg);
                }).finally(()=>{
                  this.rowData = this.data;
                  // go to first page on the ag grid after the search results are fetched
                  this.gridApi.paginationGoToPage(0);
                });;
              } 
              
            }
            this.spinnerService.setIsLoading(false);
          })
          .catch((err: HttpErrorResponse) => {
            this.notificationService.failure(err.message);
            this.spinnerService.setIsLoading(false);
          });
      }
    }));

    this.personOfInterestService.personOfInterestDataChanged.subscribe(
      (dataChanged: boolean) => {
        if (dataChanged) {
          this.searchService
            .smartSearchAPI(null)
            .then(() => {
              this.data = this.searchService.searchRecords;
              if (!this.searchField.nativeElement.value.trim()) {
                this.data?.sort((a, b) => this.sort(a, b, 'LastName'));
              }
              this.data = this.data.filter((f) => f.Active)
              if (this.data) {
                this.data.forEach(element => {
                  var photoArray: Photos[] = this.setPhotoArray( element.PhotoIDs,element.PhotoXIDs,element.PhotoS3KeyNames,element.PhotoDescriptions,element.PhotoLogicalFileNames,element.PhotoActives,element.PrimaryPhotoID);  
                  element.PrimaryPhotoArray = [];
                  if(photoArray){
                    var primaryPhotoArray: Photos[] = photoArray.filter((f) => f.IsPrimary == true && f.Active); //get PrimaryPhoto Array
                    element.PrimaryPhotoArray = primaryPhotoArray;
                  }
                  element.PhotosArray = photoArray;
                  element.AttachmentsArray = this.setAttachmentArray(element.AttachmentIDs,element.AttachmentXIDs,element.AttachmentS3KeyNames, element.AttachmentDescriptions, element.AttachmentLogicalFileNames, element.AttachmentActives); 
                  element.AliasArray = this.setAliasArray( element.AliasIDs,element.AliasNames,element.AliasActives);
                  element.Aliases = element.AliasNames;
                  element.RecordID = element.PersonOfInterestID;  
                  element.Requester = new POIRequester(element.RequesterID,element.RequesterFirstName,element.RequesterLastName,element.RequesterEmail,element.RequesterPhone,element.RequesterCompany,element.RequesterDepartment,element.RequesterPosition,element.RequesterActive)               
                 });
                    
                //call getPOIFiles Api to set base64 for primary Photo Id , hence pass only the primaryPhoto into primaryPhotoArray 
               
                if(this.data){
                  this.commonService.getPrimaryPhotoFiles(this.data).then(() =>{
                    this.commonService.primaryPhotoFileRecords.forEach(element => {
                        if(element.Photos.length > 0){
                          this.data.filter((f) => f.PersonOfInterestID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
                          this.data.filter((f) => f.PersonOfInterestID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURL = element.Photos[0].SignedURL; 
                        }       
                      });
                    
              
                  }).catch((err)=>{
                    this.notificationService.failure(err.msg);
                  }).finally(()=>{
                    this.rowData = this.data;
                  });;
                } 
              }
              this.spinnerService.setIsLoading(false);
            })
            
        }
      }
    );

    this.loadGridState()
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.addEventListener('firstDataRendered', () => {
      this.loadGridState();
    });

    setTimeout(() => {
      params.api.showLoadingOverlay();
     }, 0);
     params.api.hideOverlay();

    this.photoRefreshInterval = setInterval(() => {
      this.refreshPhotos();
    }, 300000); // 5 mins
  }

  getHeaderJsonData() {
    this.sharedService.getHeaderJsonData().subscribe((res: any) => {
      this.headerJsondata = res;
    });
  }

  onGridStateChanged() {
    this.gridStateChanged$.next();
  }

  isColumnVisible(field: string): boolean {
    const column = this.columnApi?.getColumn(field);
    return column ? column.isVisible() : false;
  }

  toggleColumn(field: string, event: any) {
    const isChecked = event.target.checked;
    this.columnApi?.setColumnVisible(field, isChecked);
    return { field, isChecked };
  }

  agGridPopUpModal(screenName: string, tableName: string) {
    const originalColumnState = this.columnApi?.getColumnState().map(col => ({ ...col }));
    const dialogRef = this.dialog.open(CommonGridcolumnShowhideModalComponent, {
      data: {
        pages: this.headerJsondata?.pages || [],
        columnApi: this.columnApi,
        screenName,
        tableName
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.forEach((colState: { field: string; isChecked: boolean }) => {
          this.columnApi?.setColumnVisible(colState.field, colState.isChecked);
        });
        this.onGridStateChanged();
      }else {
        if (originalColumnState) {
          this.columnApi?.setColumnState(originalColumnState);
        }
      }
    });
  }

  loadGridState() {
    const payload = {
      "UserID": this.userService.userID,
      "ScreenName": this.searchService.getPageName(),
      "DeviceWidth": window.innerWidth,
      "TableName": "PersonOfInterest"
    }
    this.sharedService.getUserGridSettings(payload)
      .subscribe((response: any) => {
        if (response?.length > 0) {
          this.applyGridSettings(response);
        }
      }, error => {
        console.error('Error loading grid settings:', error);
      });
  }

  applyGridSettings(gridSettings: any) {
    setTimeout(() => {
      gridSettings.forEach(setting => {
        const column = this.columnApi?.getColumn(setting.FieldName);
        if (column) {
          this.columnApi?.moveColumn(setting.FieldName, setting.Position - 1);
          this.columnApi?.setColumnWidth(setting.FieldName, setting.Width || 200);
          this.columnApi?.setColumnVisible(setting.FieldName, !!setting.Visible);
        }
      });
    }, 100);
  }


  saveGridState() {
    if (!this.columnApi) return;
    const columnState = this.columnApi?.getColumnState().map(col => ({
      FieldName: col.colId,
      Position: this.columnApi
        .getColumnState().findIndex(c => c.colId === col.colId) + 1,
      Width: col.width,
      Visible: !col.hide ? 1 : 0
    }));

    const payload = {
      "UserID": this.userService.userID,
      "ScreenName": this.searchService.getPageName(),
      "DeviceWidth": window.innerWidth,
      'TableName': "PersonOfInterest",
      "data": columnState
    };

    this.sharedService.setUserGridSettings(payload)
      .subscribe(response => {
        console.log('Grid settings saved successfully:', response);
      }, error => {
        console.error('Error saving grid settings:', error);
      });
  }



  getDropdownData() {
    this.personOfInterestService.getRegionTree().then((result) => {
      this.treeDropdownService.setData(result);
    });
  }

  
  onSearchBtnClick(event: KeyboardEvent | null = null) {
    event?.preventDefault()
    const key = this.searchField.nativeElement.value.trim()
      ? this.searchField.nativeElement.value.trim()
      : null;
    this.searchService.smartSearchAPI(key);
    this.searchService.searchInitiated.emit(true);
    this.searchField.nativeElement.select();
  }

  onSearchFilterChange(value: string) {
    this.selectedSearchFilter = value;
    this.searchService.selectedSearchFilter = value;
    localStorage.setItem("searchType", value);
    this.searchService
      .userSearchTypeUpdate(value, this.userService.userID)
      .subscribe((res: HttpResponse<any>) => {
        console.log("response", res);
      });
  }
  // opens view poi modal on grid row click
  viewPoi(event: any) {
    if (event.node.rowPinned) {
    return;
  }
    this.clickedPoi = event.data;
    this.dialog.open(ViewPersonOfInterestModalComponent, {
      data: this.clickedPoi,
    });
  }

  setPhotoArray(PhotoIDs: string,PhotoXIDs: string,PhotoS3KeyNames : string,PhotoDescriptions : string,PhotoLogicalFileNames : string,PhotoActives : string, PrimaryPhotoID: number): Photos[]{
    var photosArray: Photos[] = [] ;
    
    if(PhotoIDs == null){      
      return photosArray;
    } else {
      var photoIdArray = PhotoIDs.split(",");
      var photoS3KeyNamesArray = PhotoS3KeyNames.split(",");
      var photoDescriptionsArray = PhotoDescriptions.split(",");
      var photoLogicalFileNamesArray = PhotoLogicalFileNames.split(",");
      var photoActivesArray = PhotoActives.split(",");
      var photoXID = PhotoXIDs.split(",");
      var index: number = 0;
      photoIdArray.forEach(element => {       
        var photo : Photos = {"XID":photoXID[index],"File": null,"ThumbnailFile" : null,"PhotoID": Number(photoIdArray[index]), Active: Boolean(Number(photoActivesArray[index])),Description: photoDescriptionsArray[index]
       , SignedURL:"",
        SignedURLThumbnail:"",
        LogicalFileName: photoLogicalFileNamesArray[index],
        S3KeyName: photoS3KeyNamesArray[index],
        UserID: 1,        
        IsPrimary : (Number(photoIdArray[index]) == PrimaryPhotoID)? true : false,
        Index: 0,
        BaseName:photoLogicalFileNamesArray[index].replace(/\.[^/.]+$/, ""),
        Ext:photoLogicalFileNamesArray[index].substring(photoLogicalFileNamesArray[index].lastIndexOf('.')+1, photoLogicalFileNamesArray[index].length)|| "",
        
      }
      photosArray.push(photo);
      index++;
       
      });
      return photosArray;
    }
  }

  setAttachmentArray(AttachmentIDs: string,AttachmentXIDs: string,AttachmentS3KeyNames : string,AttachmentDescriptions : string,AttachmentLogicalFileNames : string,AttachmentActives : string):Attachments[]{
    var attachmentsArray: Attachments[] = [] ;
   
    if(AttachmentIDs == null){      
      return attachmentsArray;
    } else {
      var attachmentIdArray = AttachmentIDs.split(",");
      var attachmentS3KeyNamesArray = AttachmentS3KeyNames.split(",");
      var attachmentDescriptionsArray = AttachmentDescriptions.split(",");
      var attachmentLogicalFileNamesArray = AttachmentLogicalFileNames.split(",");
      var attachmentActivesArray = AttachmentActives.split(",");
      var attcahmnetXidsArray = AttachmentXIDs.split(",")
      var index: number = 0;
      attachmentIdArray.forEach((element) => {
        var attachment: Attachments = {
          XID: attcahmnetXidsArray[index],
          AttachmentID: Number(attachmentIdArray[index]),
          Active: Boolean(Number(attachmentActivesArray[index])),
          Description: attachmentDescriptionsArray[index],
          LogicalFileName: attachmentLogicalFileNamesArray[index],
          S3KeyName: attachmentS3KeyNamesArray[index],
          UserID: 1,
          Path: "",
          SignedURL: "",
          File: null,
          Index:0,
          BaseName:attachmentLogicalFileNamesArray[index].replace(/\.[^/.]+$/, ""),
          Ext:attachmentLogicalFileNamesArray[index].substring(attachmentLogicalFileNamesArray[index].lastIndexOf('.')+1, attachmentLogicalFileNamesArray[index].length)|| "",
          OrginalFileName:attachmentLogicalFileNamesArray[index]
        };
        index++;
        attachmentsArray.push(attachment);
      });
      return attachmentsArray;
    }
  }

  setAliasArray(AliasIDs: string, AliasNames: string, AliasActives: string) {
    var aliasArray: Array<{
      Active: number;
      AliasID: number;
      Name: string;
      UserID: number;
    }> = [];

    if (AliasIDs == null) {
      return aliasArray;
    } else {
      var aliasIdArray = AliasIDs.split(",");
      var aliasNamesArray = AliasNames.split(",");
      var aliasActivesArray = AliasActives.split(",");
      var index: number = 0;
      aliasIdArray.forEach((element) => {
        var alias = {
          Active: Number(aliasActivesArray[index]),
          AliasID: Number(aliasIdArray[index]),
          Name: aliasNamesArray[index],
          UserID: 1,
        };
        index++;
        aliasArray.push(alias);
      });
      return aliasArray
    }
  }


  heightFormatter(params: any){
    if(params.value){
      var realFeet = ((params.value*0.393700) / 12);      
      var feet = Math.floor(realFeet);
      var inches = Math.round((realFeet - feet) * 12);
      return
      feet +
        "' " +
        inches? (inches) +
        '"' :"";
    }
  }

 deletePOI() {
    this.dialogService
      .openConfirmDialog(
        "Confirm Person Of Interest Delete",
        "Are you sure you want to delete selected Person Of Interest ?"
      )
      .afterClosed()
      .subscribe((confirm: boolean) => {
        if (confirm) {        
         
              this.personOfInterestService.deletePOI(
                this.selectedPoi
              ).then().catch((err) => {
                this.notificationService.failure(err)
              });
              
            }  
      });

   
  }

  // open search filter modal
  onFilterBtnClick() {
    const dialogRef = this.dialog.open(SearchFilterModalComponent, {
      disableClose: false,
      data: { pageName: this.searchService.getPageName() },
      backdropClass: "backdropBackground",
    });
  }

   onDownload() {
    console.log("key", this.searchService.key);
           const dialogRef = this.dialog.open(DownloadGridComponent, {
            disableClose: true,
            data: {
              ScreenName: this.searchService.getPageName(),
              searchKey: this.searchService.key
            },
            backdropClass: "backdropBackground",
          }); 
    }
  clearSearchField() {
    this.searchField.nativeElement.value = "";
    this.onSearchBtnClick();
  }

  sort(a: any, b: any, fieldName: string): number {
    const valueA = a[fieldName] ? a[fieldName]?.toString()?.toLowerCase()?.trim() : '';
    const valueB = b[fieldName] ? b[fieldName]?.toString()?.toLowerCase()?.trim() : '';

    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  }

  ngOnDestroy() {
    if (this.photoRefreshInterval) {
      clearInterval(this.photoRefreshInterval);
    }
    this.subscription?.unsubscribe();
  }

  onSearchChange(value: string) {
    if (value === '') {
      this.onSearchBtnClick();
    }
  }

  private refreshPhotos(): void {
    if (!this.data?.length) {
      return;
    }
    this.commonService.getPrimaryPhotoFiles(this.data)
      .then(() => {
        this.commonService?.primaryPhotoFileRecords?.forEach(element => {
          if (element?.Photos?.length > 0) {
            const poi = this.data?.find(f => f.PersonOfInterestID === element.RecordID);
            if (poi?.PrimaryPhotoArray?.length > 0) {
              poi.PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
              poi.PrimaryPhotoArray[0].SignedURL = element.Photos[0].SignedURL;
            }
          }
        });
        this.gridApi.refreshCells({
          columns: ['POIProfile'],
          force: true
        });
      })
      .catch((err) => {
        this.notificationService.failure(err);
      });
  }

  
}
